import React from 'react';
import {LandingPagePropTypes, NeuroMessage} from '@ignitesales/neuro-application/src/neuro-guide';
import WarningMessage from '../WarningMessage';

const LandingPage = ({ componentClass, onStartGuideClick, isLoadingNextPage }) => {
  return (
    <div className={componentClass}>
      <div className={`${componentClass}__container`}>
        <WarningMessage warningState={false} />
        <div className={`${componentClass}__container--sixty`}>
          <div className="background">
            <img src="/classpath/assets/images/background-landing.jpg" />
          </div>
        </div>

        <div className={`${componentClass}__container--forty`}>
          <div className={`${componentClass}__message`}>
            <NeuroMessage id="landing.title" tagName="h1" />
            <NeuroMessage id="landing.message" tagName="h2"/>
            <button onClick={() => onStartGuideClick()} disabled={isLoadingNextPage} className="btn btn-primary">
              <NeuroMessage id="landing.getStarted" />
            </button>
          </div>
        </div>

      </div>
      <div className="decoration decoration__landing">
        <div className="blue-circle"></div>
        <div className="yellow-circle"></div>
      </div>
    </div>
  );
};

LandingPage.propTypes = LandingPagePropTypes;

export default LandingPage;
